import { showCookiePreferencesModal } from "@/app/utils/cookieConsent";
import React from "react";

type CookiePreferencesButtonProps = {
	className?: string;
	children?: React.ReactNode;
};

const CookiePreferencesButton: React.FC<CookiePreferencesButtonProps> = ({
	className,
	children = "Mostrar preferências de cookie",
}) => (
	<button
		type="button"
		data-cc="show-preferencesModal"
		className={className}
		onClick={showCookiePreferencesModal}
	>
		{children}
	</button>
);

export default CookiePreferencesButton;
